





























































import { Vue, Component, Inject, Prop } from "vue-property-decorator";

// Types
import { IAccount } from "@/models/accounts";
import {
  IAffiliateProvider,
  IAffiliateProviderMethods
} from "@/models/providers/affiliate";
import { ClientTemplateSlotCodes } from "@/data/enums/templates";
import { IState } from "@/store";

@Component({
  components: {
    "affiliate-stats-grid": () =>
      import("@/components/app/global/affiliate/statsGrid.vue"),
    "affiliate-referrals-table": () =>
      import("@/components/app/global/affiliate/affiliateReferralsTable.vue"),
    "affiliate-links-table": () =>
      import("@/components/app/global/affiliate/affiliateLinksTable.vue"),
    "client-template-render-provider": () =>
      import(
        `@/components/app/global/templates/clientTemplateRenderProvider.vue`
      )
  }
})
export default class ClientAffiliateOverview extends Vue {
  // Inject

  @Inject({ from: "affiliateProviderMethods" })
  public readonly $affiliateMethods!: IAffiliateProviderMethods;

  @Inject({ from: "affiliateProvider" })
  public readonly $affiliateData!: () => IAffiliateProvider;

  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Computed

  public get affiliateData() {
    return this.$affiliateData();
  }

  public get clientTemplateProps() {
    return {
      code: ClientTemplateSlotCodes.AFFILIATES_OVERVIEW,
      objectId: (this.$store.state as IState).user?.id
    };
  }
}
